import { useMemo, useState } from 'react';
import { useDlgSeries, type DlgPlatform } from '@entities/dialogs';
import { addDays, num, StepChart, type ChartPoint } from '@shared/ui/v2';

const SERIES = [
  { key: 'dialogs', label: 'Диалоги', color: '#1F2937' },
  { key: 'clients', label: 'Клиенты', color: '#2563EB' },
  { key: 'unanswered', label: 'Без ответа', color: '#D97706' },
];

interface Props {
  aid: string;
  platform: DlgPlatform;
  channelId?: string | null;
}

/** График экрана 8 — по образцу статистики Telegram (утверждён 28.10.2026). */
export function DialogsChart({ aid, platform, channelId }: Props) {
  const [step, setStep] = useState<'day' | 'hour'>('day');
  const [range, setRange] = useState<{ from: string; to: string } | null>(null);
  const today = useMemo(
    () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Moscow' }),
    [],
  );
  const r = range ?? { from: addDays(today, step === 'hour' ? -2 : -29), to: today };
  const { data, isFetching } = useDlgSeries(
    aid,
    { platform, channelId, step, from: r.from, to: r.to },
    true,
  );
  return (
    <StepChart
      title="Статистика"
      series={SERIES}
      points={(data?.points ?? []) as unknown as ChartPoint[]}
      overview={(data?.overview ?? []) as unknown as ChartPoint[]}
      overviewKey="dialogs"
      step={step}
      onStep={(s) => {
        setStep(s);
        setRange(s === 'hour' ? { from: addDays(today, -2), to: today } : null);
      }}
      range={r}
      onRange={setRange}
      today={today}
      fetching={isFetching}
      fmt={num}
      emptyText="За этот период диалогов нет"
    />
  );
}
